require('./RAIndexRiskModal.scss');
// @vendor
const React = require('react');
const PropTypes = require('prop-types');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const { recordLink } = require('utilities/tagging');

// @commons
const OKModal = require('components/commons/OKModal/OKModal');

// @assets
const petronas = require('../../assets/icons/buildings/KualaLumpur_modal.svg');
const shangai = require('../../assets/icons/buildings/Shanghai_modal.svg');
const taipei = require('../../assets/icons/buildings/Taipei_modal.svg');
const wtc = require('../../assets/icons/buildings/NewYork_modal.svg');
const khalifa = require('../../assets/icons/buildings/Dubai_modal.svg');

const petronasIcon = require('../../assets/icons/buildings/KualaLumpur_circle.svg');
const shangaiIcon = require('../../assets/icons/buildings/Shanghai_circle.svg');
const taipeiIcon = require('../../assets/icons/buildings/Taipei_circle.svg');
const wtcIcon = require('../../assets/icons/buildings/NewYork_circle.svg');
const khalifaIcon = require('../../assets/icons/buildings/Dubai_circle.svg');

class RAIndexRiskModal extends React.Component {
    constructor(props) {
        super(props);

        this.handleModalClose = this.handleModalClose.bind(this);
        this.handleButtonClick = this.handleButtonClick.bind(this);
        this.handleShowModal = this.handleShowModal.bind(this);
    }

    handleButtonClick() {
        this.props.onModalClose();
        recordLink(
            'modal estrategia de inversion indices de riesgo',
            'entendido',
        );
    }

    handleModalClose() {
        this.props.onModalClose();
        recordLink('modal estrategia de inversion indices de riesgo', 'salir');
    }

    handleShowModal() {
        recordLink('modal estrategia de inversion indices de riesgo', 'vista');
    }

    render() {
        const { isModalOpen } = this.props;
        const contentModal = (
            <div className="ra-index-risk-modal__parent-div">
                <div className="ra-index-risk-modal__portfolio-div">
                    <div className="ra-index-risk-modal__icon-div">
                        <img
                            className="ra-index-risk-modal__icon ra-index-risk-modal__icon-first-icon"
                            src={petronas}
                        />
                        <div className="ra-index-risk-modal__height-lenght">
                            <FormattedText value="raIndexRiskModel-shardLength" />
                        </div>
                        <div className="ra-index-risk-modal__risk-capacity">
                            <FormattedText value="raStrategyItem-lowRisk" />
                        </div>
                        <div className="ra-index-risk-modal__city--kualalumpur">
                            <FormattedText value="raIndexRiskModel-petronasCity" />
                        </div>
                    </div>
                    <div className="ra-index-risk-modal__icon-div">
                        <img
                            className="ra-index-risk-modal__icon ra-index-risk-modal__icon-second-icon"
                            src={shangai}
                        />
                        <div className="ra-index-risk-modal__height-lenght">
                            <FormattedText value="raIndexRiskModel-shangaiLength" />
                        </div>
                        <div className="ra-index-risk-modal__risk-capacity">
                            <FormattedText value="raStrategyItem-midLowRisk" />
                        </div>
                        <div className="ra-index-risk-modal__city--shanghai">
                            <FormattedText value="raIndexRiskModel-shangaiCity" />
                        </div>
                    </div>
                    <div className="ra-index-risk-modal__icon-div">
                        <img
                            className="ra-index-risk-modal__icon ra-index-risk-modal__icon-third-icon"
                            src={taipei}
                        />
                        <div className="ra-index-risk-modal__height-lenght">
                            <FormattedText value="raIndexRiskModel-petronasLength" />
                        </div>
                        <div className="ra-index-risk-modal__risk-capacity">
                            <FormattedText value="raStrategyItem-midRisk" />
                        </div>
                        <div className="ra-index-risk-modal__city--taipei">
                            <FormattedText value="raIndexRiskModel-raIndexRiskModel_taipeiCity" />
                        </div>
                    </div>
                    <div className="ra-index-risk-modal__icon-div">
                        <img
                            className="ra-index-risk-modal__icon ra-index-risk-modal__icon-fourth-icon"
                            src={wtc}
                        />
                        <div className="ra-index-risk-modal__height-lenght">
                            <FormattedText value="raIndexRiskModel-wtcLength" />
                        </div>
                        <div className="ra-index-risk-modal__risk-capacity">
                            <FormattedText value="raStrategyItem-midHighRisk" />
                        </div>
                        <div className="ra-index-risk-modal__city--newyork">
                            <FormattedText value="raIndexRiskModel-wtcCity" />
                        </div>
                    </div>
                    <div className="ra-index-risk-modal__icon-div">
                        <img
                            className="ra-index-risk-modal__icon ra-index-risk-modal__icon-fifth-icon"
                            src={khalifa}
                        />
                        <div className="ra-index-risk-modal__height-lenght">
                            <FormattedText value="raIndexRiskModel-khalifaLength" />
                        </div>
                        <div className="ra-index-risk-modal__risk-capacity">
                            <FormattedText value="raStrategyItem-highRisk" />
                        </div>
                        <div className="ra-index-risk-modal__city--dubai">
                            <FormattedText value="raIndexRiskModel-khalifaCity" />
                        </div>
                    </div>
                </div>
                <div className="ra-index-risk-modal__description-div">
                    <div>
                        <img
                            className="ra-index-risk-modal__description-icon"
                            src={petronasIcon}
                        />
                        <div className="ra-index-risk-modal__description-details">
                            <div className="ra-index-risk-modal__description-details-height-portfolio">
                                <FormattedText value="raIndexRiskModel-shardLength" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-city">
                                <FormattedText value="raIndexRiskModel-petronasCity" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-risk-capacity">
                                <FormattedText value="raIndexRiskModel-shardRiskCapacity" />
                            </div>
                            <div>
                                <FormattedText value="raIndexRiskModel-descriptionForShard" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <img
                            className="ra-index-risk-modal__description-icon"
                            src={shangaiIcon}
                        />
                        <div className="ra-index-risk-modal__description-details">
                            <div className="ra-index-risk-modal__description-details-height-portfolio">
                                <FormattedText value="raIndexRiskModel-shangaiLength" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-city">
                                <FormattedText value="raIndexRiskModel-shangaiCity" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-risk-capacity">
                                <FormattedText value="raIndexRiskModel-petronasRiskcapacity" />
                            </div>
                            <div>
                                <FormattedText value="raIndexRiskModel-petronasDescription" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <img
                            className="ra-index-risk-modal__description-icon"
                            src={taipeiIcon}
                        />
                        <div className="ra-index-risk-modal__description-details">
                            <div className="ra-index-risk-modal__description-details-height-portfolio">
                                <FormattedText value="raIndexRiskModel-petronasLength" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-city">
                                <FormattedText value="raIndexRiskModel-raIndexRiskModel_taipeiCity" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-risk-capacity">
                                <FormattedText value="raIndexRiskModel-shangaiRiskCapacity" />
                            </div>
                            <div>
                                <FormattedText value="raIndexRiskModel-shangaiDescription" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <img
                            className="ra-index-risk-modal__description-icon"
                            src={wtcIcon}
                        />
                        <div className="ra-index-risk-modal__description-details">
                            <div className="ra-index-risk-modal__description-details-height-portfolio">
                                <FormattedText value="raIndexRiskModel-wtcLength" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-city">
                                <FormattedText value="raIndexRiskModel-wtcCity" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-risk-capacity">
                                <FormattedText value="raIndexRiskModel-wtcRiskCapacity" />
                            </div>
                            <div>
                                <FormattedText value="raIndexRiskModel-wtcDescription" />
                            </div>
                        </div>
                    </div>
                    <div>
                        <img
                            className="ra-index-risk-modal__description-icon"
                            src={khalifaIcon}
                        />
                        <div className="ra-index-risk-modal__description-details">
                            <div className="ra-index-risk-modal__description-details-height-portfolio">
                                <FormattedText value="raIndexRiskModel-khalifaLength" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-city">
                                <FormattedText value="raIndexRiskModel-khalifaCity" />
                            </div>
                            <div className="ra-index-risk-modal__description-details-risk-capacity">
                                <FormattedText value="raIndexRiskModel-khalifaRiskCapacity" />
                            </div>
                            <div>
                                <FormattedText value="raIndexRiskModel-khalifaDescription" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <OKModal
                content={contentModal}
                footerType="navigation"
                isOpen={isModalOpen}
                onAfterOpen={this.handleShowModal}
                onCloseCallback={this.handleModalClose}
                onPrimaryButtonClick={this.handleButtonClick}
                primaryButtonText="raCustomModel-modelButton"
                shouldCloseOnOverlayClick={false}
                size="large"
                title="raIndexRiskModel-indexModelTitle"
                titleAlignment="center"
            />
        );
    }
}

RAIndexRiskModal.propTypes = {
    isModalOpen: PropTypes.bool.isRequired,
    onModalClose: PropTypes.func.isRequired,
};

module.exports = RAIndexRiskModal;
